import { useSelector } from "react-redux";

import { useAlgoliaActions } from "store/AlgoliaSlice";
import { SORT_ITEMS } from "enums";

const useAlgolia = () => {
  const {
    addOneFilter,
    removeOneFilter,
    clearFilter,
    clearAllFilters,
    setIsClearAllClicked,
    setItemToRemove,
    setSortFilterSelected,
  } = useAlgoliaActions();
  const { castNumFilters, templateGroupTypeFilters, isClearAllClicked, itemToRemove, sortFilterSelected } = useSelector(
    (state) => state.AlgoliaSlice,
  );

  const isDefaultSort = sortFilterSelected?.label === SORT_ITEMS.bestMatch.label;

  return {
    addOneFilter,
    removeOneFilter,
    clearFilter,
    clearAllFilters,
    castNumFilters,
    templateGroupTypeFilters,
    isClearAllClicked,
    setIsClearAllClicked,
    itemToRemove,
    setItemToRemove,
    setSortFilterSelected,
    sortFilterSelected,
    isDefaultSort,
  };
};

export default useAlgolia;
